/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { Outlet } from "react-router-dom";
import { BreadcrumbList } from "cms/shared/breadcrumb";
import { ErrorDisplay } from "cms/shared/error_display";
import { useSimpliCity } from "cms/hooks/use-simplicity";
import { EnvWrapper } from "cms/auth/components/env-wrapper";
import { ServicesSideNav } from "layout/services-side-nav";
import { ServicesHeader } from "components/services-header";

const ServicesLayout = (props) => {
    const { crumbs, selectedSection } = props;
    const { error } = useSimpliCity();

    return (
        <>
            <EnvWrapper>
                <ServicesHeader />

                <div className='two-column-services'>
                    <div className='two-column-services-main-content'>
                        <div className='two-column-services-left'>
                            <ServicesSideNav selectedSection={selectedSection} />
                        </div>
                        <div className='two-column-services-right'>
                            <div className='two-column-services-main-content'>
                                <h1>{selectedSection}</h1>
                                <BreadcrumbList crumbs={crumbs} />
                                <div>
                                    <Outlet />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ErrorDisplay error={error} />

            </EnvWrapper>
        </>
    );
};

export { ServicesLayout };
